export default __webpack_public_path__ + "static/media/WFUSE.380fa22b.svg";